module.exports = __webpack_public_path__ + "static/media/freeMarketAdvantage1.610b3de3.svg";